<template>
    <div class="body-bg container-fluid promotion-container">
        <h3 class="mt-3">Claimed Promotions</h3>
        <template v-if="isPromotionsFetching">
            <div
                class="d-flex justify-content-center align-items-center my-3"
                style="gap: 8px;"
            >
                <van-loading type="spinner" />
                Loading...
            </div>
        </template>
        <div v-else>
            <template v-if="!userClaimedPromotions.length">
                <NoPromotions />
            </template>
            <template v-else>
                <PromotionCard
                    v-for="(promotion, index) in userClaimedPromotions"
                    :key="index"
                    :promotion="promotion"
                />
            </template>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import PromotionCard from '../components/PromotionCard.vue';
import NoPromotions from '../../promotions/components/NoPromotions.vue';

export default {
    components: {
        PromotionCard,
        NoPromotions
    },
    computed: {
        ...mapState('promotions', ['userClaimedPromotions', 'isPromotionsFetching'])
    },
    methods: {
        ...mapActions('promotions', ['fetchUserPromotions'])
    },
    async mounted() {
        try {
            await this.fetchUserPromotions();
        } catch (error) {
            this.$toast.fail('Something went wrong!');
        }
    }
}
</script>

<style scoped>
.body-bg {
    overflow-x: hidden;
}

.promotion-card {
    background: rgba(2, 175, 255, 0.1);
}

.animate-charcter {
    text-transform: uppercase;
    background-image: linear-gradient(-225deg,
            #B50200 0%,
            #f3e706 29%,
            #B50200 67%,
            #f3e706 100%);
    background-size: auto auto;
    background-clip: border-box;
    background-size: 200% auto;
    color: #fff;
    background-clip: text;
    color: transparent;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: textclip 2s linear infinite;
    display: inline-block;
    /* font-size: 190px; */
}

@keyframes textclip {
    to {
        background-position: 200% center;
    }
}
</style>
